module.exports = __webpack_public_path__ + "assets/media/mobile-illustration.89ab8c76.png";